export var getters = {
    hasActiveBetas: function (state) {
        return state.userBetas.some(function (beta) { return beta.stage === 'beta'; });
    },
    isBetaActiveForCurrentUser: function (state) {
        return state.userBetas.some(function (beta) { return beta.isEnrolled; });
    },
};
